import App from './App';

const Sign = ({match}) => (
    <div className="archk-template-docs-wrapper">
        <App match={match} />
    </div>
)

export default Sign
